import { useEffect } from "react";
/**
 * @deprecated
 * @param emitter
 * @returns
 */
export function useGlobalUpdate(emitter) {
    return {
        emit: (state) => {
            if (state instanceof Function) {
                emitter.state = state(emitter.state);
            }
            else {
                emitter.state = state;
            }
            emitter.listeners.forEach((listener) => listener.f(emitter.state));
        },
        useListener: (callback, id) => {
            useEffect(() => {
                emitter.listeners.push({
                    f: callback,
                    id,
                });
                return () => { };
            }, []);
        },
        get state() {
            return emitter.state;
        },
    };
}
